// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IServicePackagePeriod } from './ServicePackagePeriod';

export interface IPublishTerm {
  /**
   * Количество доступных действий
   * Сколько типов размещения можно купить.
   * Например, Москва - Некоммерческий, 1 шт.
   */
  availableActionsCount?: number;
  /** Базовая ставка аукциона (стоимость продвижения) **/
  baseAuctionBet?: number;
  /** Для использования услуги необходимо пройти идентификацию **/
  identificationRequired: boolean;
  /** Несопоставимые типы услуг **/
  incompatibleServices?: EIncompatibleServices[];
  /** Дополнительная ли услуга **/
  isAdditional: boolean;
  /** Доступна ли автоматическая пролонгация выбранного типа размещения для объявления **/
  isAutoProlongAvailable: boolean;
  /** Доступно применение **/
  isAvailable: boolean;
  /** Выбрано по умолчанию **/
  isDefault: boolean;
  /** Уникальный ключ тарифа **/
  key: string;
  /** Периоды публикации объявлений из стандартной тарифной сетки. **/
  periods: IServicePackagePeriod[];
  /** Набор услуг для идентификации записи в тарифной сетке **/
  services: EServices[];
  /** Причина недоступности **/
  unavailableReasonType?: EUnavailableReasonType;
  /** Тип продвижения **/
  promotionType: EPromotionType;
  /** Услуга должна быть предвыбрана **/
  isRecommended: boolean;
}
export enum EIncompatibleServices {
  /** Платное **/
  'Paid' = 'paid',
  /** Премиум-объявление **/
  'Premium' = 'premium',
  /** Топ 3 **/
  'Top3' = 'top3',
  /** Выделение цветом **/
  'Highlight' = 'highlight',
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  'Calltracking' = 'calltracking',
  /** Бесплатное **/
  'Free' = 'free',
  /** Аукцион **/
  'Auction' = 'auction',
}
export enum EServices {
  /** Платное **/
  'Paid' = 'paid',
  /** Премиум-объявление **/
  'Premium' = 'premium',
  /** Топ 3 **/
  'Top3' = 'top3',
  /** Выделение цветом **/
  'Highlight' = 'highlight',
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  'Calltracking' = 'calltracking',
  /** Бесплатное **/
  'Free' = 'free',
  /** Аукцион **/
  'Auction' = 'auction',
}
export enum EUnavailableReasonType {
  /** Только для участников акции "Работаем честно" **/
  'OnlyInAction' = 'onlyInAction',
  /** Для ТОП-3 нужны фото **/
  'NoPhotos' = 'noPhotos',
  /** Не выполнены условия необходимые для размещения объявлений в ТОП 3 **/
  'Top3ServiceDenied' = 'top3ServiceDenied',
  /** Возможность продвижения объявлений для Вашего аккаунта заблокирована администрацией **/
  'DeniedBySanctions' = 'deniedBySanctions',
  /** Доступно после окончания периода публикации Премиум **/
  'OnlyAfterPremiumServiceExpiration' = 'onlyAfterPremiumServiceExpiration',
  /** Нет доступных услуг **/
  'NoServicesAvailable' = 'noServicesAvailable',
  /** Недостаточно денег **/
  'NotEnoughMoney' = 'notEnoughMoney',
  /** Возможность создания бесплатных объявлений для Вашего аккаунта заблокирована администрацией **/
  'FreeServiceDenied' = 'freeServiceDenied',
  /** Возможность создания объявлений с выделением цветом для Вашего аккаунта заблокирована администрацией **/
  'HighlightServiceDenied' = 'highlightServiceDenied',
  /** Недостаточно средств для оплату у агентства **/
  'NotEnoughMoneyOnAgencyAccount' = 'notEnoughMoneyOnAgencyAccount',
  /** Исчерпан лимит объявлений для субагента **/
  'SubAgentLimitExceeded' = 'subAgentLimitExceeded',
  /** Когда у субагента есть запрет на топ и премиум **/
  'DeniedByMaster' = 'deniedByMaster',
}
export enum EPromotionType {
  /** Без продвижения **/
  'NoPromotion' = 'noPromotion',
  /** Стандарт **/
  'Standard' = 'standard',
  /** Премиум **/
  'Premium' = 'premium',
  /** Топ **/
  'Top' = 'top',
}
